import axios from 'axios';
import authHeader from '../services/AuthHeader';
import {ENV_URL} from './Globals';
const PARTNERS_API_URL = `${ENV_URL}/api/v1/partners`;



class PartnerService {

    getAllPartners() {
        return axios.get(`${PARTNERS_API_URL}`, {
            headers: authHeader()
        });   
    }


    createPartner(data) {
        return axios.post(`${PARTNERS_API_URL}`, data , {
                headers: authHeader()
        });
    }

  
     getPartner(id) {
        return axios.get(`${PARTNERS_API_URL}/${id}`, {
            headers: authHeader() 
        });
    };

    updatePartner(partnerId,data) {
        return axios.put(`${PARTNERS_API_URL}/${partnerId}`, data , {
            headers: authHeader()
        });
    };

   deletePartner(id) {
    return axios.delete(`${PARTNERS_API_URL}/${id}`, {
        headers: authHeader()
    });
};

}

const partnerService = new PartnerService();
export default partnerService;